import { DeleteVehicleContext } from 'components/StraightThroughVehicleComp/RemoveVehicleContext/DeleteVehicleContext'
import { RemoveVehicleContext } from 'components/StraightThroughVehicleComp/RemoveVehicleContext/RemoveVehicleContext'
import { RemoveVehicleValidationForm } from 'components/StraightThroughVehicleComp/ValidationForms/RemoveVehicleValidationForm'
import React, { useContext, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { submitEndorsement } from 'services/Api'
import { storageData } from 'services/Services'

const RemoveVehicleBtnNav = () => {
    const navigate = useNavigate()
    const [isSubmitting, setIsSubmitting] = useState(false);
    const removeVehicleContext = useContext(RemoveVehicleContext)
    const deleteVehicleContext = useContext(DeleteVehicleContext)
    var removeVehicleClass = removeVehicleContext?.removeVehicleClass
    var deletedVehicle = deleteVehicleContext?.deleteVehicle
    var formFilled = deletedVehicle?.requestedRemovalEffDate != "" && deletedVehicle?.vehicleRemovalReason != ""
    var screen = window.location.pathname.split("/").pop()
    var currentComponent = deletedVehicle?.componentTracker

    const navigateBack = () => {
        // First page
        if (screen == "remove-vehicle") {
            // Return to home page
            if (currentComponent != "VehicleDriverAssignment") {
                removeVehicleContext?.clear()
                window.location.href = "/home"
            }
            // Return to form
            else if (currentComponent == "VehicleDriverAssignment") {
                deletedVehicle["componentTracker"] = ""

                var removeVehicleClassCopy = removeVehicleClass
                removeVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles[0] = deletedVehicle
                removeVehicleClassCopy.screenName = (currentComponent == "VehicleDriverAssignment") ? "Vehicle" : "Driver Assignment"
                removeVehicleContext.setRemoveVehicleClass({ ...removeVehicleClassCopy });
                storageData.setItem("RemoveVehicleClass", JSON.stringify(removeVehicleClassCopy))
            }
        }
        // Confirm page
        else if (screen == "remove-vehicle-confirm") {
            // Navigate to back to main remove vehicle page if only one vehicle on policy
            if (removeVehicleClass?.vehicles?.vehiclesOnPolicy?.storedVehicles?.length == 1) {
                navigate("/endorsement/remove-vehicle")
            }
            // Return to driver assignment page
            else {
                var removeVehicleClassCopy = removeVehicleClass
                removeVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles[0] = deletedVehicle
                removeVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles[0]["componentTracker"] = "VehicleDriverAssignment"
                removeVehicleClassCopy.screenName = "Driver Assignment"
                removeVehicleClassCopy.driverAssignment.vehicles = removeVehicleForDriverAssignment(removeVehicleClassCopy)
                removeVehicleContext?.setRemoveVehicleClass({ ...removeVehicleClassCopy })
                storageData.setItem("RemoveVehicleClass", JSON.stringify(removeVehicleClassCopy))
                navigate("/endorsement/remove-vehicle")
            }
        }
    }

    // Removes the vehicle from the driver assignment list
    const removeVehicleForDriverAssignment = (removeVehicleClassCopy) => {
        var driverAssignmentVehicles = removeVehicleClassCopy.vehicles.vehiclesOnPolicy.storedVehicles
        driverAssignmentVehicles = driverAssignmentVehicles.filter(veh =>
            veh?.VIN != removeVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles[0].VIN
        );
        return driverAssignmentVehicles
    }

    // Next button component navigation
    const nextButtonNavigate = async () => {
        if (screen == "remove-vehicle") {
            var alertMsg = RemoveVehicleValidationForm(removeVehicleClass, deletedVehicle, removeVehicleClass.driverAssignment.vehicles, removeVehicleClass.driverAssignment.drivers, removeVehicleContext.userData.state)

            if (alertMsg) {
                removeVehicleContext.setValidationMsgToggle(
                    alertMsg?.title || 'Oops!',
                    alertMsg?.message || 'Please certify that the answers to the questions listed in the change are true and accurate to the best of your knowledge to submit your request.'
                );
                return;
            }

            // Navigate to confirm page if only one vehicle on policy
            if (removeVehicleClass?.vehicles?.vehiclesOnPolicy?.storedVehicles?.length == 1) {
                var removeVehicleClassCopy = removeVehicleClass
                removeVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles[0] = deletedVehicle
                removeVehicleContext?.setRemoveVehicleClass({ ...removeVehicleClassCopy })
                storageData.setItem("RemoveVehicleClass", JSON.stringify(removeVehicleClassCopy))
                navigate("/endorsement/remove-vehicle-confirm")
            }
            // Navigate to driver assignment page
            else if (currentComponent != "VehicleDriverAssignment") {
                var removeVehicleClassCopy = removeVehicleClass
                removeVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles[0] = deletedVehicle
                removeVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles[0]["componentTracker"] = "VehicleDriverAssignment"
                removeVehicleClassCopy.screenName = "Driver Assignment"
                removeVehicleClassCopy.driverAssignment.vehicles = removeVehicleForDriverAssignment(removeVehicleClassCopy)
                removeVehicleContext?.setRemoveVehicleClass({ ...removeVehicleClassCopy })
                storageData.setItem("RemoveVehicleClass", JSON.stringify(removeVehicleClassCopy))
            }
            // Navigate to confirm page
            else if (currentComponent == "VehicleDriverAssignment") {
                navigate("/endorsement/remove-vehicle-confirm")
            }
        }
        else if (screen == "remove-vehicle-confirm") {
            if (!removeVehicleContext?.removeVehicleClass?.confirmation) {
                removeVehicleContext.setValidationMsgToggle("Oops!", "Please certify that the answers to the questions listed in the change are true and accurate to the best of your knowledge to submit your request.")
                return;
            }
            // Send endorsement class to backend
            var req = {
                "requestType": "Remove Vehicle",
                "classRequest": storageData.getItem("RemoveVehicleClass")
            }
            setIsSubmitting(true);
            removeVehicleContext?.setSubmissionLoad(true); // Display spinner and hide nav buttons

            // Api call to send data
            try {
                const response = await submitEndorsement(req);
                storageData.setItem("responseData", JSON.stringify(response.data));
                redirectWithRemoves(response.data?.requestStatus)
            } catch (error) {
                console.error("Error submitting endorsement:", error);
                removeVehicleContext?.setSubmitEndorsementResponse({ error: true, message: "An error occurred while submitting the endorsement." });
            } finally {
                setIsSubmitting(false);
                removeVehicleContext?.setSubmissionLoad(false); // Hide spinner and display nav buttons
            }
        }
    }

    // Removes last 2 pages from history stack to allow back button to home
    const redirectWithRemoves = (status) => {
        window.history.pushState(null, null, window.location.href);
        window.history.go(-2);
        window.history.replaceState(null, null, window.location.href);

        if (status == "Failed") {
            window.location.replace('/endorsement/remove-vehicle-thank-you')
        }
        else if (status == "Blocked") {
            window.location.replace('/endorsement/remove-vehicle-block')
        }
        else {
            window.location.replace('/endorsement/remove-vehicle-summary');
        }
    }

    return (
        <>
            <div className="mt-2 mb-3">
                <div>
                    {!removeVehicleContext?.submissionLoad &&
                        <>
                            {/* Back Button */}
                            <button type="button" className="btn btn-default editCancelBtn" onClick={() => { navigateBack() }}>
                                BACK
                            </button>
                            {/* Continue Button */}
                            {removeVehicleContext?.removeVehicleClass?.vehicles?.vehiclesOnPolicy?.removedVehicles?.length > 0 && formFilled && screen != "remove-vehicle-confirm" &&
                                <button type="submit" className="btn btn-primary-grad right pull-right editCancelBtn" onClick={() => { nextButtonNavigate() }}>
                                    NEXT
                                </button>
                            }
                            {/* Submit Button (Only for Confirm Page) */}
                            {screen == "remove-vehicle-confirm" &&
                                <button type="submit" className="btn btn-primary-grad right pull-right editCancelBtn" onClick={() => { nextButtonNavigate() }}>
                                    SUBMIT
                                </button>
                            }
                        </>
                    }
                    {/* Spinner for retrieving vehicle info from vin */}
                    {removeVehicleContext?.submissionLoad &&
                        <div className="text-center">
                            <Spinner animation="border" />
                        </div>
                    }

                </div>
            </div>
        </>
    )
}

export default RemoveVehicleBtnNav